<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList" :isLimit="false">
      <template slot="self-config">
        <el-form-item label="可用变量表">
        <el-table
            :data="showWordFileList"
            style="width:600px">
            <el-table-column
              prop="variableName"
              label="变量名">
            </el-table-column>
            <el-table-column
              prop="variable"
              label="变量">
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="模板上传">
        <div class="exportword-upload">
          <el-upload
            ref='fileupload'
            class="upload-demo"
            :action="fileUrl"
            :accept='accept'
            :before-upload="beforeUpload"
            :on-success='successCb'
            :on-remove='removeCb'
            :file-list='fileList'>
            <el-button size="small" type="primary">{{upload_name}}</el-button>
            <div slot="tip" class="el-upload__tip">只支持上传.docx格式文档,且不超过5M</div>
          </el-upload>
          <a :href="form.downFile.url" :download="form.downFile.name" class="downloadBtn" v-show="fileList.length>0">下载文档</a>
        </div>
      </el-form-item>
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: -1,
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: '',  // 所选模型
          wordFileList: [{
            variableName: '导出操作时间',
            variable: 'output_time'
          }, {
            variableName: '导出操作用户名',
            variable: 'output_username'
          }, {
            variableName: '导出操作用户姓名',
            variable: 'output_realname'
          }],
          downFile: {
            url: '',
            name: '',
            source_url: ''
          }
        },
        showWordFileList: [{
          variableName: '导出操作时间',
          variable: '${output_time}'
        }, {
          variableName: '导出操作用户名',
          variable: '${output_username}'
        }, {
          variableName: '导出操作用户姓名',
          variable: '${output_realname}'
        }],
        upload_name: '上传',
        fileUrl: HOST + 'admin/upload',
        fileList: [],
        removeCb: null,
        successCb: null,
        accept: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            if (res.data.config) {
              if (res.data.config.downFile) {
                this.form.downFile = res.data.config.downFile
                if (this.form.downFile.url && this.form.downFile.url != '') {
                  this.fileList.push(res.data.config.downFile)
                }
              }
            }
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getInputList() {  // 获取控件列表
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            this.inputList = res.data
            _(this.inputList).forEach((item) => {
              this.form.wordFileList.push({
                field_id: item.default.field_id,
                variableName: item.default.title,
                variable: item.default.name
              })
              this.showWordFileList.push({
                field_id: item.default.field_id,
                variableName: item.default.title,
                variable: '${' + item.default.name + '}'
              })
            })
          }
        })
      },
      beforeUpload(file) {
        let size = file.size / 1024 / 1024
        let len = file.name.toString().split('.').length
        let type = file.name.toString().split('.')[len - 1]
        if (size > 5) {
          _g.toastMsg(this, 'error', '上传的文件不能超过5M')
          return false
        }
        if (type == 'docx') {
          return true
        } else {
          _g.toastMsg(this, 'error', '上传的文件格式不对，需要上传.doc/.docx文档')
          return false
        }
      },
      init() {
        this.removeCb = (file, fileList) => {
          this.fileList = []
          if (this.fileList.length == 0) {
            this.form.downFile = {}
          }
          document.getElementsByName('file')[0].value = null
          this.upload_name = '上传'
        }
        this.successCb = (res, file, fileList) => {
          if (res.code == 200) {
            if (fileList.length > 1) {
              fileList.shift()
            }
            this.form.downFile = {
              url: HOST + res.data,
              name: fileList[0].name,
              source_url: res.data
            }
            this.fileList = fileList
            this.upload_name = '重新上传'
          } else {
            this.fileList = []
            _g.toastMsg(this, 'error', res.error)
          }
        }
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
      this.init()
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig]
  }
</script>
<style scoped>
  .downloadBtn{
    padding:5px 10px;
    border: 1px solid #20a0ff;
    color: #fff;
    background-color: #20a0ff;
    font-size: 12px;
    border-radius: 4px;
  }
  .downloadBtn:hover{
    border: 1px solid #4db3ff;
    background-color: #4db3ff;
  }
  .exportword-upload{
    width: 600px;
  }
</style>


// WEBPACK FOOTER //
// exportWord.vue?793a5c43